var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2736.12 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2736.12,
    height: 2000,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M903.15,637.89s-27.79-128.62-191.77-154.13c0,0,50.97,190.02,191.77,154.13Z",
    fill: "#6b7898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.05,700.57s54.2-220.03-180.26-383.45c0,0-64.73,332.56,180.26,383.45Z",
    fill: "#91b7c6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2460.86,1875.85l-439.59-2.62-31.07-.09h-2.31l-3.94-.02-32.58-.09-29.34-.09h-3.44l-69.35-.22h-3.44l-29.3-.09-38.83-.12-29.34-.08h-3.44l-908.08-2.73-480.48,7.31S-8.32,1646.03,131.74,1065.98c42.26-175,285.76-440.77,584.66-460.54,364.64-24.12,328.59-404.14,1013.15-378.45,730.7,27.41,1092.2,1089.06,731.32,1648.86Z",
    fill: "#fef8e5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2021.27 1873.23 1990.2 1873.13 1987.89 1873.13 1983.95 1873.11 1951.37 1873.02 1922.03 1872.93 1920.31 1872.93 1918.52 1154.33 1918.47 1136.33 1920.32 1136.33 1949.54 1136.25 1988.37 1136.15 2019.43 1136.07 2019.43 1136.11 2019.86 1306.83 2021.1 1803.94 2021.27 1873.23",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1990.2 1873.13 1987.89 1873.13 1983.95 1873.11 1951.37 1873.02 1949.58 1155.87 1949.58 1154.25 1949.54 1136.29 1949.54 1136.25 1988.37 1136.15 1988.37 1136.18 1988.41 1154.16 1988.41 1155.77 1990.11 1834.91 1990.12 1838.35 1990.18 1862.22 1990.19 1869.11 1990.2 1873.13",
    fill: "#7e83a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.63,1008.43l50.8,127.65h0c.02,8.42-6.92,15.27-15.49,15.29-8.58,.02-15.55-6.79-15.57-15.22,.02,8.43-8.65,15.28-19.38,15.3-10.72,.03-19.43-6.78-19.45-15.21,.02,8.43-6.92,15.27-15.49,15.29-8.58,.02-15.55-6.79-15.57-15.22h0l50.16-127.9Z",
    fill: "#f7e09c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019.43,1136.07s-17.44,13.26-31.06,.08l.04,18.01,31.06-.08-.05-18.01Z",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.54,1136.25s-17.44,13.26-31.06,.08l.05,18.01,31.06-.08-.05-18.01Z",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988.37,1136.15s-16.78,16.98-38.83,.1l.05,19.62,38.83-.1-.05-19.62Z",
    fill: "#7e83a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.5,1050.82s-15.32,12.06-33.53,.08l16.66-42.48,16.87,42.39Z",
    fill: "#7e83a0"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2001.34 1085.95 1999.74 1086.59 1998.15 1087.23 1984.05 1051.81 1968.64 1013.11 1953.46 1051.82 1920.32 1136.33 1920.19 1136.64 1920.19 1137.84 1920.21 1143.29 1920.24 1154.33 1922.03 1872.93 1920.31 1872.93 1918.59 1872.92 1916.75 1136 1916.87 1135.7 1968.62 1003.75 2001.34 1085.95"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2018.6,
    y: 1306.83,
    width: 3.44,
    height: 497.11,
    transform: "translate(-4.84 6.3) rotate(-.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1961.47,
    y: 1849.79,
    width: 38.27,
    height: 3.44,
    transform: "translate(-610.28 2650.4) rotate(-60.21)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1998.39 1854.79 1990.19 1869.11 1987.89 1873.13 1983.95 1873.11 1990.18 1862.22 1995.4 1853.09 1998.39 1854.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1847.58 1872.71 1845.81 1872.7 1816.51 1872.62 1777.68 1872.5 1748.33 1872.41 1746.61 1872.4 1745.19 1301.67 1745.14 1283.67 1747 1283.67 1776.21 1283.6 1815.04 1283.49 1846.1 1283.42 1846.1 1283.46 1846.14 1301.42 1846.53 1454.18 1847.58 1872.71",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1816.51 1872.62 1777.68 1872.5 1776.25 1303.22 1776.21 1283.63 1776.21 1283.6 1815.04 1283.49 1815.04 1283.52 1815.09 1301.5 1815.09 1303.12 1816.51 1872.62",
    fill: "#6b7898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.3,1155.77l50.8,127.65h0c.02,8.43-6.92,15.27-15.49,15.29-8.58,.02-15.55-6.79-15.57-15.22,.02,8.42-8.65,15.28-19.38,15.3-10.72,.03-19.43-6.78-19.45-15.21,.02,8.43-6.92,15.27-15.49,15.29-8.58,.02-15.55-6.79-15.57-15.22h0l50.16-127.9Z",
    fill: "#f7e09c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.1,1283.42s-17.44,13.26-31.06,.08l.04,18.01,31.06-.08-.04-18.01Z",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.2,1283.59s-17.44,13.26-31.06,.08l.04,18.01,31.06-.08-.05-18.01Z",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.04,1283.5s-16.78,16.98-38.83,.1l.05,19.62,38.83-.1-.05-19.62Z",
    fill: "#6b7898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1812.17,1198.17s-15.32,12.06-33.53,.08l16.66-42.48,16.87,42.39Z",
    fill: "#6b7898"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1828 1233.3 1826.41 1233.94 1824.81 1234.58 1810.71 1199.15 1795.31 1160.45 1780.13 1199.17 1747 1283.67 1746.86 1283.99 1746.86 1285.19 1746.88 1290.64 1746.91 1301.67 1748.33 1872.41 1746.61 1872.4 1744.9 1872.4 1743.42 1283.34 1743.54 1283.04 1795.29 1151.1 1828 1233.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1849.24 1872.71 1847.58 1872.71 1845.81 1872.7 1844.5 1454.19 1846.53 1454.18 1847.93 1454.17 1849.24 1872.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 652.91,
    y: 1200.71,
    width: 247.86,
    height: 522.96,
    transform: "translate(-852.34 1166.8) rotate(-51.74)",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.87,
    cy: 1455.9,
    r: 90.79,
    transform: "translate(-804.28 970.1) rotate(-45)",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.72,
    y: 1167.39,
    width: 247.86,
    height: 522.96,
    transform: "translate(-827.01 1152.39) rotate(-51.74)",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.23,
    cy: 1436.42,
    r: 90.8,
    transform: "translate(-712.34 2098.7) rotate(-85.24)",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M694.44,1365.62c26.78-33.96,68.93-48.63,108.76-41.97l-147.16-116.04-124.21,157.52,147.16,116.04c-15.77-37.18-11.33-81.6,15.45-115.55Z",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.02,1507.23c-26.78,33.96-68.93,48.63-108.76,41.97l128.01,100.94,124.21-157.52-128.01-100.94c15.77,37.18,11.33,81.6-15.45,115.55Z",
    fill: "#c6e2ed"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "494.78 1397.59 492.59 1364.28 530.62 1394.26 494.78 1397.59",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1056.71 1493.47 1058.9 1526.78 1025.34 1533.25 1056.71 1493.47",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "905.43 1721.41 903.24 1688.09 1056.71 1493.47 1058.9 1526.78 905.43 1721.41",
    fill: "#5c818c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655.5,
    y: 1416.37,
    width: 247.86,
    height: 32.53,
    transform: "translate(-828.15 1157.58) rotate(-51.74)",
    fill: "#53617f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "689.92 1519.88 682.56 1545.66 706.73 1564.73 715.46 1540.02 689.92 1519.88",
    fill: "#e28b67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 594.18,
    y: 1364.39,
    width: 254.31,
    height: 536.56,
    transform: "translate(-1022.32 2014.22) rotate(-78.51)",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.13,
    cy: 1630.59,
    r: 93.16,
    transform: "translate(-1067.76 1641.06) rotate(-66.77)",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.78,
    y: 1334.88,
    width: 254.3,
    height: 536.56,
    transform: "translate(-1007.34 1973.53) rotate(-78.51)",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 716.2,
    cy: 1605.65,
    r: 93.16,
    transform: "translate(-27.87 12.72) rotate(-1)",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M601.23,1582.27c8.84-43.48,40.67-76.4,80.25-88.7l-188.42-38.31-41.01,201.69,188.42,38.31c-31.63-26.78-48.08-69.52-39.24-112.99Z",
    fill: "#c6e2ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.16,1629.03c-8.84,43.48-40.67,76.4-80.25,88.7l163.9,33.33,41.01-201.69-163.9-33.33c31.63,26.78,48.08,69.52,39.24,112.99Z",
    fill: "#c6e2ed"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "433.1 1703.81 415.7 1674.3 464.39 1684.2 433.1 1703.81",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "992.17 1532.01 1009.57 1561.52 981.81 1582.96 992.17 1532.01",
    fill: "#6791a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "958.9 1810.73 941.5 1781.22 992.17 1532.01 1009.57 1561.52 958.9 1810.73",
    fill: "#5c818c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.9,
    y: 1587.71,
    width: 254.3,
    height: 33.38,
    transform: "translate(-1003.66 1980.52) rotate(-78.51)",
    fill: "#6b7898"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.36 1725.68 673.53 1752.7 704.49 1759 701.07 1732.33 668.36 1725.68",
    fill: "#6b7898"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "551.65 1442.44 992.17 1532.01 1009.57 1561.52 1001.95 1599.01 1058.9 1526.78 492.42 1393.71 551.65 1442.44",
    fill: "#5c818c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M974.36,1738.76c-.26,.06-.54,.07-.83,0-1.07-.22-1.77-1.27-1.55-2.34l35.49-174.56-16.56-28.09-522.99-106.34-50.28,247.26c-.22,1.07-1.26,1.77-2.34,1.55-1.07-.22-1.77-1.27-1.55-2.34l51.07-251.15,528.61,107.48,18.23,30.93-35.8,176.05c-.16,.79-.77,1.38-1.51,1.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M694.56,1293.81c-1.02,.23-2.05-.38-2.34-1.4-.3-1.05,.31-2.15,1.37-2.45l34.73-9.86c1.04-.28,2.15,.31,2.45,1.37,.3,1.05-.31,2.15-1.37,2.45l-34.73,9.86s-.07,.02-.11,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.28,1302.72c-1.02,.23-2.05-.38-2.34-1.39-.3-1.05,.31-2.15,1.37-2.45l34.73-9.86c1.06-.28,2.15,.31,2.45,1.37,.3,1.05-.31,2.15-1.37,2.45l-34.73,9.86s-.07,.02-.11,.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1057.15,1495.4c-.56,.13-1.17,0-1.66-.38l-409.09-322.59-151.78,192.47,2.08,31.68,56.17,44.3c.86,.68,1.01,1.93,.33,2.79-.68,.86-1.93,1.01-2.79,.33l-57.56-45.39-2.3-34.96,.47-.6,154.7-196.19,412.2,325.05c.86,.68,1.01,1.92,.33,2.78-.29,.37-.69,.61-1.12,.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "731.42 1874.83 731.36 1659.61 697.75 1659.62 697.74 1633.68 697.67 1633.68 697.67 1632.74 683.14 1632.74 683.13 1606.78 697.66 1606.78 697.74 1606.78 697.73 1579.87 697.65 1579.87 697.65 1579.87 597.3 1579.9 597.3 1579.9 478.83 1579.93 478.84 1605.89 464.24 1605.9 464.24 1607.79 464.24 1607.79 464.24 1633.75 478.85 1633.75 478.85 1634.7 478.85 1659.71 451.44 1659.72 451.44 1661.62 451.44 1661.62 451.45 1687.57 478.86 1687.57 478.86 1688.52 478.87 1713.53 460.55 1713.53 460.55 1714.48 460.55 1714.48 460.56 1741.39 485.93 1741.38 485.93 1742.31 485.94 1767.32 485.94 1768.24 460.57 1768.25 460.58 1795.16 460.58 1795.16 460.58 1796.11 478.89 1796.1 478.9 1821.11 456.87 1821.12 456.87 1823.02 456.87 1823.02 456.87 1848.98 508.71 1848.96 508.72 1874.9 731.42 1874.83",
    fill: "#fff690"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.24,
    y: 1605.86,
    width: 233.11,
    height: 27.83,
    fill: "#ffef6b"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 451.44,
    y: 1659.66,
    width: 233.11,
    height: 27.83,
    fill: "#ffef6b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.7,
    y: 1713.47,
    width: 233.11,
    height: 26.91,
    fill: "#ffef6b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.08,
    y: 1767.29,
    width: 233.11,
    height: 26.86,
    fill: "#ffef6b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.73,
    y: 1821.06,
    width: 233.11,
    height: 26.88,
    fill: "#ffef6b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "875.82 1877 631.96 1874.86 631.95 1847.95 850.85 1847.89 875.82 1877",
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.98,
    y: 1821,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.66,
    y: 1794.1,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.02,
    y: 1767.21,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.64,
    y: 1740.33,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.95,
    y: 1713.42,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.53,
    y: 1686.52,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.94,
    y: 1659.6,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.33,
    y: 1632.7,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.92,
    y: 1605.78,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.85,1794.09v-26.91h-25.38v-26.88h18.31v-26.91h-27.42v-26.9h27.41v-26.92h-14.61v-26.9h14.59v-26.91l-100.35,.03c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27-3.26,7.74-7.29,7.74h0c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73h0c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-12.81c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73h12.81c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-3.72c-4.03,0-7.3,3.47-7.3,7.74v11.41c0,4.27,3.27,7.73,7.31,7.73h10.77c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-10.77c-4.03,0-7.3,3.47-7.3,7.74v11.42c0,4.27,3.27,7.73,7.31,7.73h3.72c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-7.43c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73l124.65,2.96-24.31-19.49v-10.41h22.03v-26.91h-18.33v-26.88h25.37Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 639.32,
    y: 1631.75,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.93,
    y: 1658.65,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.52,
    y: 1685.57,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.95,
    y: 1712.47,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.64,
    y: 1739.38,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.02,
    y: 1766.26,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.03,
    y: 1793.17,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.66,
    y: 1820.06,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.95,
    y: 1846.97,
    width: 218.82,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 366.18,
    y: 1848,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.46,
    y: 1821.08,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.92,
    y: 1794.18,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.58,
    y: 1767.29,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.91,
    y: 1740.41,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.43,
    y: 1713.5,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.69,
    y: 1686.6,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.51,1686.59l101.5-.03v26.91h27.74v26.9h-18.52v26.89h25.67v26.9h-25.66v26.89h18.54v26.9h-22.28v26.92l-101.49,.03c-4.08,0-7.39-3.46-7.39-7.73v-11.44c0-4.27,3.3-7.74,7.38-7.74h7.52c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-3.76c-4.08,0-7.38-3.46-7.39-7.73v-11.42c0-4.27,3.3-7.74,7.38-7.74h10.9c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-10.9c-4.08,0-7.39-3.46-7.39-7.73v-11.42c0-4.27,3.3-7.74,7.38-7.74h3.76c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-12.96c-4.08,0-7.39-3.46-7.39-7.73v-11.44c0-4.27,3.3-7.73,7.37-7.74Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 360.68,
    y: 1685.65,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.42,
    y: 1712.55,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.9,
    y: 1739.46,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.58,
    y: 1766.34,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.58,
    y: 1793.25,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.93,
    y: 1820.14,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.17,
    y: 1847.05,
    width: 221.33,
    height: 1.9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.42,1723.88c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,1672.03c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15.01,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.43,1592.83c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15.01,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.82,1642.63c-.48,4.45-4.35,5.64-4.35,5.64,0,0,3.87,1.19,4.35,5.64,.48-4.45,4.35-5.64,4.35-5.64,0,0-3.87-1.19-4.35-5.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.74,1567.88c-.89,8.28-8.1,10.5-8.1,10.5,0,0,7.21,2.22,8.1,10.5,.89-8.28,8.1-10.5,8.1-10.5,0,0-7.21-2.22-8.1-10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.29,1772.22c-.78,7.24-7.09,9.19-7.09,9.19,0,0,6.31,1.94,7.09,9.18,.78-7.24,7.09-9.19,7.09-9.19,0,0-6.31-1.94-7.09-9.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.13,1640.82c-.57,5.32-5.2,6.74-5.2,6.74,0,0,4.63,1.42,5.2,6.74,.57-5.32,5.2-6.74,5.2-6.74,0,0-4.63-1.42-5.2-6.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.36,1799.86c-.8,7.46-7.3,9.47-7.3,9.47,0,0,6.5,2,7.31,9.46,.8-7.46,7.3-9.47,7.3-9.47,0,0-6.5-2-7.31-9.46Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1982.87 1874.83 1982.81 1659.61 1949.2 1659.62 1949.19 1633.68 1949.11 1633.68 1949.11 1632.74 1934.59 1632.74 1934.58 1606.78 1949.11 1606.78 1949.18 1606.78 1949.18 1579.87 1949.1 1579.87 1949.1 1579.87 1848.75 1579.9 1848.75 1579.9 1730.28 1579.93 1730.29 1605.89 1715.68 1605.9 1715.68 1607.79 1715.68 1607.79 1715.69 1633.75 1730.29 1633.75 1730.29 1634.7 1730.3 1659.71 1702.89 1659.72 1702.89 1661.62 1702.89 1661.62 1702.89 1687.57 1730.31 1687.57 1730.31 1688.52 1730.32 1713.53 1712 1713.53 1712 1714.48 1712 1714.48 1712.01 1741.39 1737.38 1741.38 1737.38 1742.31 1737.39 1767.32 1737.39 1768.24 1712.02 1768.25 1712.02 1795.16 1712.02 1795.16 1712.02 1796.11 1730.34 1796.1 1730.35 1821.11 1708.31 1821.12 1708.32 1823.02 1708.32 1823.02 1708.32 1848.98 1760.16 1848.96 1760.17 1874.9 1982.87 1874.83",
    fill: "#f7ce5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1715.69,
    y: 1605.86,
    width: 233.11,
    height: 27.83,
    fill: "#e8b437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1702.89,
    y: 1659.66,
    width: 233.11,
    height: 27.83,
    fill: "#e8b437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1708.15,
    y: 1713.47,
    width: 233.11,
    height: 26.91,
    fill: "#e8b437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.52,
    y: 1767.29,
    width: 233.11,
    height: 26.86,
    fill: "#e8b437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1708.18,
    y: 1821.06,
    width: 233.11,
    height: 26.88,
    fill: "#e8b437"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1892.84,
    y: 1847.92,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.87,
    y: 1821,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1896.54,
    y: 1794.1,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1921.91,
    y: 1767.21,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1896.52,
    y: 1740.33,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.83,
    y: 1713.42,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1887.41,
    y: 1686.52,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.82,
    y: 1659.6,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1900.21,
    y: 1632.7,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.8,
    y: 1605.78,
    width: 218.9,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2140.73,1794.09v-26.91h-25.38v-26.88h18.31v-26.91h-27.42v-26.9h27.41v-26.92h-14.61v-26.9h14.59v-26.91l-100.35,.03c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27-3.26,7.74-7.29,7.74h0c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73h0c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-12.81c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73h12.81c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-3.72c-4.03,0-7.3,3.47-7.3,7.74v11.41c0,4.27,3.27,7.73,7.31,7.73h10.77c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-10.77c-4.03,0-7.3,3.47-7.3,7.74v11.42c0,4.27,3.27,7.73,7.31,7.73h3.72c4.03,0,7.3,3.46,7.3,7.73v11.44c0,4.27-3.26,7.74-7.29,7.74h-7.43c-4.03,0-7.3,3.47-7.3,7.74v11.44c0,4.27,3.27,7.73,7.31,7.73l100.35-.03v-26.91h22.03v-26.91h-18.33v-26.88h25.37Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1900.2,
    y: 1631.75,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.81,
    y: 1658.65,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1887.41,
    y: 1685.57,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.83,
    y: 1712.47,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1896.52,
    y: 1739.38,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1921.9,
    y: 1766.26,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1921.91,
    y: 1793.17,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1896.54,
    y: 1820.06,
    width: 218.82,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1892.83,
    y: 1846.97,
    width: 218.82,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1617.63,
    y: 1848,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1639.91,
    y: 1821.08,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1621.37,
    y: 1794.18,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.03,
    y: 1767.29,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1621.35,
    y: 1740.41,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1639.87,
    y: 1713.5,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1612.14,
    y: 1686.6,
    width: 221.4,
    height: 26.91,
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.96,1686.59l101.5-.03v26.91h27.74v26.9h-18.52v26.89h25.67v26.9h-25.66v26.89h18.54v26.9h-22.28v26.92l-101.49,.03c-4.08,0-7.39-3.46-7.39-7.73v-11.44c0-4.27,3.3-7.74,7.38-7.74h7.52c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-3.76c-4.08,0-7.39-3.46-7.39-7.73v-11.42c0-4.27,3.3-7.74,7.38-7.74h10.9c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-10.9c-4.08,0-7.39-3.46-7.39-7.73v-11.42c0-4.27,3.3-7.74,7.38-7.74h3.76c4.08,0,7.38-3.47,7.38-7.74v-11.44c0-4.27-3.31-7.73-7.39-7.73h-12.96c-4.08,0-7.38-3.46-7.39-7.73v-11.44c0-4.27,3.3-7.73,7.37-7.74Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1612.13,
    y: 1685.65,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1639.87,
    y: 1712.55,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1621.35,
    y: 1739.46,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.02,
    y: 1766.34,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.03,
    y: 1793.25,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1621.37,
    y: 1820.14,
    width: 221.33,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1617.62,
    y: 1847.05,
    width: 221.33,
    height: 1.9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1639.87,1723.88c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.45,1672.03c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15.01,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.88,1592.83c-1.27,11.84-11.58,15.01-11.58,15.01,0,0,10.31,3.17,11.58,15.01,1.27-11.84,11.58-15.01,11.58-15.01,0,0-10.31-3.17-11.58-15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.26,1642.63c-.48,4.45-4.35,5.64-4.35,5.64,0,0,3.87,1.19,4.35,5.64,.48-4.45,4.35-5.64,4.35-5.64,0,0-3.87-1.19-4.35-5.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2101.19,1567.88c-.89,8.28-8.1,10.5-8.1,10.5,0,0,7.21,2.22,8.1,10.5,.89-8.28,8.1-10.5,8.1-10.5,0,0-7.21-2.22-8.1-10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024.11,1754.23c-1.1,10.23-10.01,12.98-10.01,12.98,0,0,8.91,2.74,10.01,12.97,1.1-10.23,10.01-12.98,10.01-12.98,0,0-8.91-2.74-10.01-12.97Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.73,1772.22c-.78,7.24-7.09,9.19-7.09,9.19,0,0,6.31,1.94,7.09,9.18,.78-7.24,7.09-9.19,7.09-9.19,0,0-6.31-1.94-7.09-9.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.58,1640.82c-.57,5.32-5.2,6.74-5.2,6.74,0,0,4.63,1.42,5.2,6.74,.57-5.32,5.2-6.74,5.2-6.74,0,0-4.63-1.42-5.2-6.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.81,1799.86c-.8,7.46-7.3,9.47-7.3,9.47,0,0,6.5,2,7.31,9.46,.8-7.46,7.3-9.47,7.3-9.47,0,0-6.5-2-7.31-9.46Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "861.58 1109.3 1310.53 949.67 1310.53 1262.94 861.58 1109.3",
    fill: "#99a1d3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1758.69 1109.3 1309.74 949.67 1309.74 1262.94 1758.69 1109.3",
    fill: "#7e83a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.93,1174.78c-6.83-49.51-122.58-88.9-264.39-88.9s-257.56,39.4-264.39,88.9h-.32v138.44c0,51.66,118.52,93.53,264.72,93.53s264.72-41.88,264.72-93.53v-138.44h-.32Z",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.53,1408.33c-70.88,0-137.55-9.76-187.71-27.48-50.68-17.91-78.59-41.93-78.59-67.63v-140.02h.55c4.28-24.1,33.46-46.41,82.43-62.93,49.62-16.75,114.72-25.97,183.32-25.97s133.7,9.22,183.32,25.97c48.97,16.53,78.15,38.83,82.43,62.93h.56v140.02c0,25.71-27.91,49.73-78.59,67.63-50.16,17.72-116.83,27.48-187.71,27.48Zm-263.13-231.97v136.85c0,12.13,6.81,23.97,20.23,35.19,13.19,11.02,32.11,20.93,56.24,29.45,49.83,17.61,116.12,27.3,186.65,27.3s136.82-9.7,186.65-27.3c24.13-8.53,43.06-18.44,56.24-29.45,13.43-11.22,20.23-23.06,20.23-35.19v-136.85h-.12l-.19-1.37c-3.22-23.37-31.82-45.3-80.51-61.73-49.3-16.64-114.05-25.8-182.31-25.8s-133,9.16-182.31,25.8c-48.7,16.44-77.29,38.36-80.51,61.73l-.19,1.37h-.12Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2423.01 1877 2428.17 1877 2416.85 1691.72 2404.1 1691.72 2423.01 1877",
    fill: "#4c322d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2242.86 1877 2237.7 1877 2249.03 1691.72 2261.78 1691.72 2242.86 1877",
    fill: "#4c322d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2464.39 1432.65 2353.32 1432.65 2294.56 1694.27 2421.84 1680.7 2464.39 1432.65",
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2209.43,1663.93s146.51,3.7,190.07,3.7c7.03,0,13.06-5.13,14.33-12.2l38.73-214.45c1.04-5.76,6.55-9.53,12.19-8.25,5.37,1.22,8.73,6.73,7.73,12.26l-43.88,242.94c-.34,1.88-1.17,3.55-2.31,4.9-2.82,5.36-8.36,9.01-14.74,9.01h-201.6c-9.24,0-16.73-7.66-16.73-17.11h0c0-9.45,6.96-20.8,16.2-20.8Z",
    fill: "#f9cd75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2399.5,1668.46c7.42,0,13.79-5.42,15.14-12.88l38.73-214.45c.46-2.57,1.89-4.78,4.03-6.23,2.13-1.44,4.68-1.93,7.18-1.36,.44,.1,.88-.18,.97-.63,.1-.45-.18-.9-.62-.99-2.94-.67-5.93-.1-8.44,1.6-2.5,1.7-4.18,4.29-4.73,7.31l-38.73,214.45c-1.21,6.67-6.9,11.52-13.53,11.52-.45,0-.82,.37-.82,.83s.37,.83,.82,.83Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2326.94,1702.82h0l79.07-.14c21.3,1.96,23.84-16.68,23.96-17.7l4.7-26.03c.08-.45-.21-.89-.65-.97-.44-.08-.87,.22-.95,.67l-4.72,26.12c-.07,.74-2.04,18.13-22.23,16.24h-.08l-79.11,.14c-.45,0-.82,.37-.81,.84,0,.46,.37,.83,.82,.83Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2421.6,1433.49h0l38.87-.06c.45,0,.82-.37,.81-.84,0-.46-.37-.83-.82-.83h0l-38.87,.06c-.45,0-.82,.37-.81,.84,0,.46,.37,.83,.82,.83Z",
    fill: "#211516"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2088.84 1856.72 2136 1857.36 2136.81 1804.92 2089.7 1807.45 2088.84 1856.72",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.06,1518.17l-12.71,5.5-14.14,6.7s-21.96,3.81-22.27,3.74c-.05-.01,1.82,3.27,1.82,3.27-27.24,3.36-113.1,6.89-127.2,8.46-8.5,.95-16.66,11.51-21.81,19.76l6.98,4.72s74.98-3.31,74.83-1.73c-.05,.5-2.16,7.94-5.45,17.68,46.31,3.1,111.17,2.8,123.21-16.29,9.88-15.66,.25-38.13-3.26-51.82Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.96,1664.8s49.05,.81,83.43-.37c11.03-.38,20.86,.4,26.67-.89,23.93-5.31,29.82-80.01,2.65-125.77-27.17-45.76-122.23,94.74-122.23,94.74l9.48,32.29Z",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2175.5 1858.39 2222.67 1859.03 2223.46 1807.45 2176.36 1809.12 2175.5 1858.39",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2208.15,1564.84s-120.48,7.7-123.96,21.61c-3.48,13.91-14.31,183.73-6.86,246.84,0,0,45.71,3.15,67.58-2.15l6.19-175.77,36.09-4.14,82.67-99.39-61.7,13Z",
    fill: "#74a3b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.04,1562.56s-92.92,26.22-96.4,40.13c-3.48,13.91-13.12,166.69-5.67,229.8,0,0,49.16,2.82,71.02-2.48l5.64-165.92,21.2,.74,51.41-90.46-47.2-11.81Z",
    fill: "#91b7c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.24,1834.5c21.72,0,29.47-3.27,29.83-3.43l.48-.21,5.7-167.06-8.98,4.23,.72,1.52,6.48-3.05-5.55,163.22c-2.35,.81-13.62,4.06-40.22,2.83l-.08,1.67c4.25,.2,8.12,.28,11.62,.28Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225.61,1781.97c2.32-8.94,2.98-96.16,3.01-99.87h-1.68c0,.89-.69,90.71-2.95,99.45l1.62,.42Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2139.26,1658.65c11.02-3.56,26.18-4.1,26.34-4.1l-.06-1.68c-.15,0-15.55,.55-26.8,4.19l.52,1.6Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2113.54,1835.52c18.56,0,31.37-3.04,31.5-3.07l.62-.15,6.3-177.98-6.87,5.53,1.05,1.31,4.02-3.23-6.13,173.03c-2.84,.61-15.23,3.06-32.12,2.88l-.02,1.68c.55,0,1.1,0,1.64,0Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.84,1785.21c2.31-13.51,.11-104.94,.01-108.82l-1.68,.04c.02,.95,2.29,95.15,.01,108.5l1.65,.28Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.87,1666.36c21.4,0,47.06-.72,75.91-2.9l-.13-1.67c-85.94,6.48-143.58,.07-144.15,0l-.19,1.66c.38,.04,26.07,2.9,68.56,2.9Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.45,1515.71c-1.66-.03-68.4,28.68-68.4,28.68l13.45,25.74,37.46-8.22,17.5-46.2Z",
    fill: "#fdb098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.04,1538.48s-.07,.02-.1,.03l-20.88,4.78c-.42,.1-.84-.17-.94-.59-.1-.42,.17-.84,.59-.94l20.88-4.78c.42-.1,.84,.17,.94,.59,.09,.38-.13,.77-.48,.9Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382.95,1526.07l-12.71,5.5-14.14,6.7s-21.96,3.81-22.27,3.74c-.05-.01,1.82,3.27,1.82,3.27-27.24,3.36-113.1,6.89-127.2,8.46-8.5,.95-16.66,11.51-21.81,19.76l6.98,4.72s74.98-3.31,74.83-1.73c-.05,.5-2.16,7.94-5.45,17.68,46.31,3.1,111.17,2.8,123.21-16.29,9.88-15.66,.25-38.13-3.26-51.82Z",
    fill: "#f9dab5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392.63,1401.2c-16.13-2.23-58.69-3.77-58.69-3.77,0,0-5.64,1.48-3.84,.65-47,8.3-52.2,43.16-52.2,43.16l-22.94,100.72-25.53,1.38c-8.26,15.66-2.19,57.89-2.19,57.89l123.66,13.94s26.73,4.41,49.34-24.59c14.96-19.18,20.04-78.07,20.04-121.11,0,0-2.57-64.79-27.64-68.26Z",
    fill: "#fdb098"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2046.25 1479.19 2163.99 1479.19 2205.06 1583.77 2087.31 1583.77 2046.25 1479.19",
    fill: "#492f2f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2205.06 1583.77 2198.91 1583.77 2157.85 1479.19 2163.99 1479.19 2205.06 1583.77",
    fill: "#332022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123.23,1528.15c1.63,4.8,.44,9.55-2.67,10.61-3.11,1.06-6.95-1.98-8.58-6.79-1.63-4.8-.44-9.55,2.67-10.61,3.11-1.06,6.95,1.98,8.58,6.79Z",
    fill: "#e6eaf2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2243.98,1575.32h-43.99v8.45h43.99c2.33,0,4.22-1.89,4.22-4.22h0c0-2.33-1.89-4.22-4.22-4.22Z",
    fill: "#332022"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2205.06,
    y: 1578.22,
    width: 27.79,
    height: 1.32,
    fill: "#492f2f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2351.06,1543.69c-.14,.05-.3,.07-.45,.03-.42-.1-.68-.52-.58-.94,.13-.55,13.05-55.5,18.55-90.07,.07-.43,.47-.72,.89-.65,.43,.07,.72,.47,.65,.89-5.51,34.63-18.45,89.63-18.58,90.18-.06,.26-.25,.46-.48,.55Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2271.07,1542.79c-.16,.06-.34,.07-.51,.01-.41-.13-.64-.57-.51-.98,.19-.61,19.37-61.46,23.37-82.49,.08-.42,.49-.7,.91-.62,.42,.08,.7,.49,.62,.91-4.02,21.13-23.22,82.06-23.42,82.67-.07,.24-.25,.41-.47,.5Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2349.03,1426.94c-.6,.06-1.22,.12-1.85,.16-.36,.02-.67-.24-.69-.6-.03-.36,.23-.66,.6-.69,26.9-1.89,31.89-21.58,31.93-21.78,.07-.35,.4-.59,.75-.53,.35,.06,.59,.38,.54,.72-.03,.2-4.99,20-31.27,22.71Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265.58,1528.27c-.35,.13-.75,0-.95-.34l-5.24-8.98,.07-.3,17.67-77.56c.11-.7,1.64-9.74,9.3-19.7,7.18-9.34,21.35-21.23,48.03-24.78,.43-.06,.82,.24,.88,.67,.06,.43-.24,.82-.67,.88-26.11,3.47-39.94,15.03-46.95,24.11-7.59,9.84-9.04,18.99-9.05,19.08v.06l-17.62,77.29,4.93,8.45c.22,.37,.09,.85-.28,1.07-.04,.02-.08,.04-.12,.06Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237.93,1528.55c-.4,.15-.84-.04-1-.44-.16-.4,.04-.86,.44-1.01l22.56-9c.42-.14,.86,.03,1.01,.44,.16,.4-.04,.85-.44,1.01l-22.56,9h-.01Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2229.42,1543.33s-8.16,19.26-2.19,57.89l29.84-16.01-8.86-28.86-18.78-13.02Z",
    fill: "#fdb098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.03,1544.38c-.09,.04-.19,.05-.3,.05-1.12-.03-111.61-3.35-147.76-.37-.89,2.37-4.97,14.64-3.83,37.07,.02,.43-.31,.8-.74,.82-.43,.02-.8-.31-.82-.74-1.29-25.42,3.9-37.69,4.12-38.2l.19-.43,.46-.04c35.73-3.06,147.3,.29,148.42,.32,.43,.01,.77,.37,.76,.8-.01,.33-.22,.6-.51,.71Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.43,1612.83c-1.83,.69-3.56,1.23-5.15,1.66-9.56,2.54-16.24,1.48-16.52,1.44-.42-.07-.71-.47-.64-.9,.07-.43,.47-.71,.9-.64,.07,.01,6.69,1.05,15.95-1.43,8.54-2.28,21.13-8.1,32.65-22.87,14.46-18.55,19.74-75.64,19.87-118.91,0-.43,.35-.78,.78-.78,.43,0,.78,.35,.78,.78-.13,43.51-5.5,101-20.2,119.86-9.67,12.41-20.12,18.65-28.41,21.79Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2367.93,1330.93s-13.19-5.61-24.9-1.58c-6.78,2.33-11.29,8.78-11.29,15.95v7.01l36.1-15.41s5.71,2.7,5.25,1.88c-.46-.82-5.16-7.84-5.16-7.84Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2331.75,1344.5v29.57s-.44,10.57,8.81,11.89l-1.73,14.1c-.64,5.24,2.49,10.26,7.52,11.85,2.46,.78,5.4,1.35,8.73,1.35,10.57,0,16.29-7.92,17.17-11.89,.88-3.96-1.76-22.89-1.76-22.89l.32-9.3-1.2-36.04-37.86,11.37Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2357.26,1358.45c.11,0,.22-.04,.31-.12,.18-.17,.18-.45,.01-.62-.06-.06-6.12-6.26-11.65-1.8-.19,.15-.22,.43-.07,.62,.15,.19,.43,.22,.62,.07,4.9-3.95,10.24,1.49,10.46,1.72,.09,.09,.2,.14,.32,.14Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2339.11,1355.8c.12,0,.25-.05,.33-.15,.16-.18,.14-.46-.04-.62-.18-.15-4.38-3.75-7.03-1.47-.18,.16-.21,.44-.05,.62,.16,.19,.44,.21,.62,.05,2.08-1.78,5.84,1.43,5.88,1.47,.08,.07,.19,.11,.29,.11Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2348.36,1360.22c0,.73,.59,1.32,1.32,1.32s1.32-.59,1.32-1.32-.59-1.32-1.32-1.32-1.32,.59-1.32,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2334.32,1358.9c0,.73,.59,1.32,1.32,1.32s1.32-.59,1.32-1.32-.59-1.32-1.32-1.32-1.32,.59-1.32,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.93,1330.46s11.18-.54,14.02,9.25c2.84,9.78-2,14.96-2.1,17.87-.1,2.92,1.88,22.58-11.93,21.11l-3.73-32.48,4.81-12.93-1.08-2.82Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2367.19,
    cy: 1359.77,
    r: 7.92,
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.78,1364.62c1.65,0,2.75-1.24,3.11-2.47,.43-1.46-.06-2.88-1.25-3.62-1.75-1.09-3.35-.39-4.16,.15,.34-.9,.88-1.55,1.6-1.95,1.56-.86,3.5-.23,3.52-.23,.12,.04,.24-.02,.28-.14,.04-.12-.02-.24-.14-.28-.09-.03-2.13-.69-3.87,.26-1,.55-1.68,1.52-2.02,2.89l-.19,.77,.56-.56c.08-.08,1.96-1.91,4.19-.53,1.23,.77,1.34,2.16,1.06,3.12-.29,1-1.17,2.16-2.68,2.16-.02,0-.03,0-.05,0-.12,0-.22,.1-.22,.22,0,.12,.1,.22,.22,.22h.05Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2361.99,1376.99s-.62,17.69-22.71,19.37l1.27-10.4s14.32,2.88,21.43-8.98Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343.7,1369.13c.09,0,.18-.06,.21-.15,.04-.12-.02-.24-.14-.28l-4.41-1.46,1.39-10.39c.02-.12-.07-.23-.19-.25-.12-.02-.23,.07-.25,.19l-1.44,10.75,4.76,1.57s.05,.01,.07,.01Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2370.82 1380.94 2369.28 1366.03 2365.58 1366.44 2365.58 1381.37 2370.82 1380.94",
    fill: "#fed497"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2365.86,1330.17s2.59,6.19-1.66,16.51c-4.25,10.32,10.91-3.85,10.91-3.85,0,0-1.05-15.1-9.25-12.66Z",
    fill: "#211516"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2364.2,1346.68s-33.65-1.99-35.73-9.88c-2.07-7.88,5.84-8.09,5.84-8.09,0,0-1.48-11.2,8.68-7.88,10.17,3.32,29,2.89,34.3,12.31,5.3,9.42-13.09,13.55-13.09,13.55Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2364.9,1352.3l-1.45,6.14-1.47-1.84s-2.88-8.82-.89-13.05,9.94,1.85,9.94,1.85l-6.13,6.89Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2337.87,1372.85c.14-.04,9.2-.83,9.2-.83,0,0-.9,3.83-4.27,4.13-3.37,.3-4.94-3.3-4.94-3.3Z",
    fill: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2136.45,1866.57h-40.74l-16.52-17.99-30.21,17.99h-6.51c-2.24,0-4.3,1.52-4.72,3.72-.57,2.96,1.69,5.55,4.55,5.55h94.73c.7,0,1.26-.56,1.26-1.26v-6.17c0-1.02-.82-1.84-1.84-1.84Z",
    fill: "#e28b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.09,1866.63v-16.72s-6.86-9.24-17.31-4.52c0,0-15.8,11.21-29.73-2.36l-34.59,15.34s-9.48,3.17-12.05,8.26h93.68Z",
    fill: "#3a3a49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2135.75,
    y: 1849.9,
    width: 0.69,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104.62,1850.08c-1.32,0-2.12-.11-2.15-.12l.1-.69c.08,.01,8.25,1.16,16.01-4.19l.39,.57c-5.56,3.83-11.33,4.42-14.36,4.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2127.03,
    y: 1861.38,
    width: 5.33,
    height: 0.69,
    transform: "translate(-676.59 1506.24) rotate(-33.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2123.86,
    y: 1860.54,
    width: 5.33,
    height: 0.69,
    transform: "translate(-676.97 1506.71) rotate(-33.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2039.08,1875.04c-1.12-.95-1.76-2.33-1.76-3.8,0-2.75,2.24-4.98,4.98-4.98h93.66c1.47,0,2.67,1.2,2.67,2.67v4.62h-.69v-4.62c0-1.09-.89-1.98-1.98-1.98h-93.66c-2.37,0-4.29,1.92-4.29,4.29,0,1.26,.55,2.45,1.51,3.27l-.45,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.62,1866.75l-.63-.3c.08-.16,1.97-4.05,9.05-7.07,6.96-2.97,37.56-16.54,37.87-16.68l.28,.63c-.31,.14-30.92,13.71-37.88,16.68-6.81,2.91-8.68,6.69-8.7,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2223.97,1866.57h-40.74l-16.52-17.99-30.21,17.99h-6.51c-2.24,0-4.3,1.52-4.72,3.72-.57,2.96,1.69,5.55,4.55,5.55h94.73c.7,0,1.26-.56,1.26-1.26v-6.17c0-1.02-.82-1.84-1.84-1.84Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223.61,1866.63v-16.72s-6.86-9.24-17.31-4.52c0,0-15.8,11.21-29.73-2.36l-34.59,15.34s-9.48,3.17-12.05,8.26h93.68Z",
    fill: "#3a3a49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.26,
    y: 1849.9,
    width: 0.69,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2192.14,1850.08c-1.32,0-2.12-.11-2.15-.12l.1-.69c.08,.01,8.25,1.16,16.01-4.19l.39,.57c-5.56,3.83-11.33,4.42-14.36,4.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2214.54,
    y: 1861.38,
    width: 5.33,
    height: 0.69,
    transform: "translate(-661.61 1554.41) rotate(-33.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2211.37,
    y: 1860.54,
    width: 5.33,
    height: 0.69,
    transform: "translate(-662.01 1555.63) rotate(-33.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.6,1875.04c-1.12-.95-1.76-2.33-1.76-3.8,0-2.75,2.24-4.98,4.98-4.98h93.66c1.47,0,2.67,1.2,2.67,2.67v4.62h-.69v-4.62c0-1.09-.89-1.98-1.98-1.98h-93.66c-2.37,0-4.29,1.92-4.29,4.29,0,1.26,.55,2.45,1.51,3.27l-.45,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.14,1866.75l-.63-.3c.08-.16,1.97-4.05,9.05-7.07,6.96-2.97,37.56-16.54,37.87-16.68l.28,.63c-.31,.14-30.92,13.71-37.88,16.68-6.81,2.91-8.68,6.69-8.7,6.73Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2264.62,
    cy: 739.79,
    r: 260.27,
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2264.62,
    cy: 739.79,
    r: 235.23,
    transform: "translate(140.18 1818) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2442.29,673.64c-165.93,21.35-177.85,67.28-177.85,67.28,55.39,24.99,177.85-67.28,177.85-67.28Z",
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2196.66,632.63s76.36,78.4,63.65,119.87c0,0-33.6-4.31-63.65-119.87Z",
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270.47,752.62c6.46-3.33,9-11.27,5.66-17.73-3.33-6.46-11.27-9-17.73-5.66s-9,11.27-5.66,17.73c3.33,6.46,11.27,9,17.73,5.66Z",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2282.43,
    y: 532.95,
    width: 51.82,
    height: 4.28,
    transform: "translate(1303.4 2680.99) rotate(-77.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2195.09,
    y: 942.37,
    width: 51.82,
    height: 4.28,
    transform: "translate(833.88 2919.56) rotate(-77.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2467.24,
    y: 757.56,
    width: 4.28,
    height: 51.82,
    transform: "translate(1187.92 3035.04) rotate(-77.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2057.83,
    y: 670.22,
    width: 4.28,
    height: 51.82,
    transform: "translate(949.33 2565.5) rotate(-77.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.22,
    y: 616.74,
    width: 25.91,
    height: 4.28,
    transform: "translate(57.77 1433.06) rotate(-32.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2065.21,
    y: 858.58,
    width: 25.91,
    height: 4.28,
    transform: "translate(-133.82 1269.05) rotate(-32.96)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.56,
    y: 946.5,
    width: 4.28,
    height: 25.91,
    transform: "translate(-119.78 363.18) rotate(-8.81)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2228.51,
    y: 507.19,
    width: 4.28,
    height: 25.91,
    transform: "translate(-53.33 347.59) rotate(-8.81)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2120.46,
    y: 917.03,
    width: 25.91,
    height: 4.28,
    transform: "translate(131.76 2098.03) rotate(-53.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2382.98,
    y: 558.29,
    width: 25.91,
    height: 4.28,
    transform: "translate(528.75 2162.99) rotate(-53.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.07,
    y: 771.68,
    width: 25.91,
    height: 4.28,
    transform: "translate(-94.34 322.12) rotate(-8.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2471.37,
    y: 703.64,
    width: 25.91,
    height: 4.28,
    transform: "translate(-78.75 388.57) rotate(-8.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2083.16,
    y: 595.58,
    width: 4.28,
    height: 25.91,
    transform: "translate(362.72 1931.99) rotate(-53.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2441.91,
    y: 858.11,
    width: 4.28,
    height: 25.91,
    transform: "translate(297.78 2329.02) rotate(-53.8)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2144.74,
    y: 538.35,
    width: 4.28,
    height: 25.91,
    transform: "translate(34.1 1221.54) rotate(-32)",
    fill: "#efcf75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2380.33,
    y: 915.33,
    width: 4.28,
    height: 25.91,
    transform: "translate(-129.88 1403.65) rotate(-32)",
    fill: "#efcf75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,1136.62h192.15c3.52-4.35,3.5-11.4-2.12-15.24-8.84-6.04-21.6-3.34-21.6-3.34,0,0,13.98-58.48-25.55-65.52-39.54-7.04-52.55,33.17-52.55,33.17,.62-26.71-63.77-76.95-100.81-24.34-9.62,13.66-13.34,25.72-13.57,36.09-.39,17.28,9.64,32.15,24.07,39.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.95,706.94h-151.79c-2.78-3.44-2.76-9.01,1.68-12.04,6.99-4.77,17.06-2.64,17.06-2.64,0,0-11.04-46.2,20.19-51.76,31.23-5.56,41.51,26.2,41.51,26.2-.49-21.1,50.38-60.78,79.64-19.23,7.6,10.79,10.54,20.32,10.72,28.51,.31,13.65-7.62,25.4-19.01,30.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.33,859.33c.21-2.86-.68-5.84-3.01-8.32-4.24-4.52-11.48-8.21-23.66-9.06,0,0,4.19-75.5-52.83-80.5-65.41-5.74-66.2,68.44-66.2,68.44,0,0-29.73-28.22-51.17,7.56,0,0-37.05-21.42-55.74,18.14-.59,1.24-.72,2.54-.51,3.75h253.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.48,925.88c.47-.97,1.1-1.91,1.92-2.78,4.16-4.43,11.26-8.05,23.2-8.88,0,0-4.11-74.01,51.8-78.92,64.12-5.62,64.9,67.09,64.9,67.09,0,0,29.14-27.67,50.16,7.41,0,0,35.24-20.37,53.81,16.07h-245.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1702.18,1680.03s-40.5,101.92-6.53,179l-778.74,6.53-71.86-6.53-63.34-39.24v-60.06l17.61-49.65,57.49-30.05h845.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1298.94,1677.35s-84.74,69.07-23.28,190.2l-435.54-6.4-49.48-41.12-8.93-82.34,34.68-41.5,49.99-19.95,432.56,1.11Z",
    fill: "#97a0d8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.44,1875.49h841.35c5.48,0,9.92-4.44,9.92-9.92s-4.44-9.92-9.92-9.92H880.44c-50.79,0-92.1-38.34-92.1-85.46s41.32-85.46,92.1-85.46h841.35c5.48,0,9.92-4.44,9.92-9.92s-4.44-9.92-9.92-9.92H880.44c-61.73,0-111.95,47.24-111.95,105.3s50.22,105.31,111.95,105.31Z",
    fill: "#fdb098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.75,1772.39h-412.89c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h412.89c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.72,1772.39h-401.13c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h401.13c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.18,1811.89h-205.81c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h205.81c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.75,1811.89h-625.37c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h625.37c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.81,1732.87s26.5,66.01,11.23,114.61l-21.53-33.27s-14.7,17.64-23.71,33.27c0,0-16.44-108.53-48.31-114.61h82.33Z",
    fill: "#6b7898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.75,1732.87H829.37c-1.22,0-2.2-.99-2.2-2.2s.99-2.21,2.2-2.21h861.38c1.22,0,2.2,.99,2.2,2.21s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M949.29,1483.4s37.59,94.58,6.06,166.13l722.72,6.06,66.69-6.06,58.78-36.42v-55.74l-16.34-46.08-53.36-27.89H949.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1355.07,1646.38l348.18,6.92,41.52-3.77,58.78-36.42v-55.74l-16.34-46.08-53.36-27.89h-384.65c3.64,2.71,5.86,4.36,5.86,4.36,0,0,36.12,84.95,0,158.63Z",
    fill: "#97a0d8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1711.93,1664.8H931.1c-5.09,0-9.21-4.12-9.21-9.21s4.12-9.21,9.21-9.21h780.83c47.13,0,85.48-35.58,85.48-79.31s-38.34-79.31-85.48-79.31H931.1c-5.09,0-9.21-4.12-9.21-9.21s4.12-9.21,9.21-9.21h780.83c57.29,0,103.89,43.84,103.89,97.73s-46.61,97.73-103.89,97.73Z",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.09,1569.27h-383.19c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h383.19c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1769.33,1569.27h-372.27c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h372.27c1.22,0,2.21,.99,2.21,2.2s-.99,2.2-2.21,2.2Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1759.32,1605.93h-191.01c-1.22,0-2.21-.99-2.21-2.2s.99-2.2,2.21-2.2h191.01c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1759.37,1532.59H977.75c-1.19,0-2.16-.99-2.16-2.2s.96-2.2,2.16-2.2h781.62c1.19,0,2.16,.99,2.16,2.2s-.96,2.2-2.16,2.2Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1711.93,1667H931.1c-6.29,0-11.41-5.12-11.41-11.41s5.12-11.41,11.41-11.41c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2c-3.86,0-7,3.14-7,7s3.14,7,7,7h780.83c56.07,0,101.69-42.85,101.69-95.53s-45.62-95.52-101.69-95.52H931.1c-3.86,0-7,3.14-7,7s3.14,7,7,7c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2c-6.29,0-11.41-5.12-11.41-11.41s5.12-11.41,11.41-11.41h780.83c58.5,0,106.1,44.83,106.1,99.93s-47.6,99.94-106.1,99.94Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1540.29,1605.93H959.9c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h580.39c1.22,0,2.2,.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M921.89,1478.55c0,5.09,4.12,9.21,9.21,9.21h407.79c5.09,0,9.21-4.12,9.21-9.21s-4.12-9.21-9.21-9.21h-407.79c-5.09,0-9.21,4.12-9.21,9.21Z",
    fill: "#69738d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1348.09,1655.59c0-5.09-4.12-9.21-9.21-9.21h-407.79c-5.09,0-9.21,4.12-9.21,9.21s4.12,9.21,9.21,9.21h407.79c5.09,0,9.21-4.12,9.21-9.21Z",
    fill: "#69738d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1631.19,1322.27s-30.44,76.59-4.91,134.52l-585.21,4.91-54-4.91-47.6-29.49v-45.13l13.23-37.31,43.2-22.58h635.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.66,1469.15h632.26c4.12,0,7.46-3.34,7.46-7.46s-3.34-7.46-7.46-7.46H1013.66c-38.16,0-69.21-28.81-69.21-64.22s31.05-64.22,69.21-64.22h632.26c4.12,0,7.46-3.34,7.46-7.46s-3.34-7.46-7.46-7.46H1013.66c-46.39,0-84.13,35.5-84.13,79.13s37.74,79.13,84.13,79.13Z",
    fill: "#fcbdab"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1312.32,1391.8h310.28c.99,0,1.79-.8,1.79-1.79s-.8-1.79-1.79-1.79h-310.28c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.43,1391.8h273.36c.89,0,1.62-.8,1.62-1.79s-.72-1.79-1.62-1.79h-273.36c-.9,0-1.62,.8-1.62,1.79s.72,1.79,1.62,1.79Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.29,1421.49h154.66c.99,0,1.79-.8,1.79-1.79s-.8-1.79-1.79-1.79h-154.66c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.29,1362.1h647.31c.99,0,1.79-.8,1.79-1.79s-.8-1.79-1.79-1.79H975.29c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1152.64,1421.49h469.96c.99,0,1.79-.8,1.79-1.79s-.8-1.79-1.79-1.79h-469.96c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79Z",
    fill: "#c2bef8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1653.37,1318.34c0,4.12-3.34,7.46-7.46,7.46h-330.19c-4.12,0-7.46-3.34-7.46-7.46s3.34-7.46,7.46-7.46h330.19c4.12,0,7.46,3.34,7.46,7.46Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1308.27,1461.7c0-4.12,3.34-7.46,7.46-7.46h330.19c4.12,0,7.46,3.34,7.46,7.46s-3.34,7.46-7.46,7.46h-330.19c-4.12,0-7.46-3.34-7.46-7.46Z",
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1105.16,1362.1s-22.14,33.51-9.77,72.86l17.43-26.94s11.9,14.28,19.2,26.94c0,0,13.99-67.94,39.8-72.86h-66.67Z",
    fill: "#ffe182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.66,1470.94h632.26c5.09,0,9.24-4.15,9.24-9.24s-4.15-9.24-9.24-9.24c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79c3.13,0,5.67,2.54,5.67,5.67s-2.54,5.67-5.67,5.67H1013.66c-45.4,0-82.34-34.7-82.34-77.35s36.94-77.35,82.34-77.35h632.26c3.13,0,5.67,2.54,5.67,5.67s-2.54,5.67-5.67,5.67c-.99,0-1.79,.8-1.79,1.79s.8,1.79,1.79,1.79c5.09,0,9.24-4.15,9.24-9.24s-4.15-9.24-9.24-9.24H1013.66c-47.37,0-85.91,36.3-85.91,80.92s38.54,80.92,85.91,80.92Z",
    fill: "#211516"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1058.2,644.87c38.02-3.03,78.31-47.98,120.54-62.8,42.24-14.81,36.5-80.45,36.5-80.45,0,0-77.8,23.4-91.61,35.06-8.67,7.33-46.47,37.64-73.66,60.11-11.9,9.83-21.77,18.16-26.28,22.41-.7,.65-1.26,1.21-1.69,1.66-.07,.08-.14,.15-.2,.21-.43,.47-.67,.8-.73,.98-1.14,3.78-.88,25.85,37.13,22.82Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1023.7,619.19c-.7,.65-1.26,1.21-1.69,1.66,2.04,2.18,4.33,4.38,6.88,6.5,2.61,2.16,6.62,1.87,9.37-.58,.14-.12,.27-.24,.39-.37l14.13-14.35s1.81-2.99-.2-9.59c-.62-2.05-1.58-3.99-2.6-5.68-11.9,9.83-21.77,18.16-26.28,22.41Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.46,618h0c.03-.07,.06-.14,.1-.22-.04,.07-.07,.14-.1,.22Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1022.01,620.86c-.07,.08-.14,.15-.2,.21,1.93,2.15,4.15,4.34,6.68,6.44,2.29,1.91,6.97,2.12,9.28-.22l.53-.54s-.03,.02-.03,.02c-2.18,1.19-5.89,.55-7.7-.96-2.61-2.16-4.87-4.41-6.85-6.61-.7,.65-1.26,1.21-1.69,1.66Z",
    fill: "#fde4cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.68,615.81c.04-.06,.06-.1,.1-.14h-.01s-.07,.09-.09,.14Z",
    fill: "#fde4cd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1043.95,646.07l.42-2.63c-10.18-1.61-17.01-5.08-20.3-10.34-2.82-4.49-2.1-9.03-1.82-10.31,6.35-5.28,99.39-82.63,110.93-90.31,11.79-7.84,81.75-29.37,82.45-29.58l-.78-2.55c-2.9,.89-71.04,21.86-83.15,29.91-12.01,7.99-107.43,87.38-111.49,90.76l-.3,.25-.12,.38c-.08,.26-1.95,6.49,1.98,12.82,3.71,5.96,11.17,9.87,22.17,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.65,733.97c47.12-13.23,86.7-79.81,136.21-108.93,49.51-29.12,26.03-110.33,26.03-110.33,0,0-92.16,48.73-106.65,66.83-8.75,10.93-46.1,55.24-74.45,89.77-13.81,16.83-25.49,31.33-30.68,38.51-.76,1.05-1.37,1.94-1.84,2.66-.11,.16-.2,.31-.29,.46-.46,.74-.71,1.24-.73,1.5-.49,5.04,5.29,32.77,52.41,19.53Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1017.11,709.82c-.76,1.05-1.37,1.94-1.84,2.66,1.32,1.23,2.7,2.44,4.14,3.64,3.66,3.05,9.32,2.62,13.18-.84h0c.18-.16,.34-.33,.51-.49l19.82-20.12s2.54-4.21-.27-13.47c-1.11-3.69-3.01-7.11-4.87-9.89-13.81,16.83-25.49,31.33-30.68,38.51Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.19,703.01h0c.06-.17,.15-.35,.23-.51-.08,.17-.15,.34-.23,.51Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1015.27,712.48c-.11,.16-.2,.31-.29,.46,1.23,1.14,2.51,2.28,3.86,3.4,3.22,2.67,9.79,2.97,13.03-.31l.72-.75c-3.05,1.71-8.28,.8-10.85-1.33-1.63-1.36-3.17-2.74-4.63-4.13-.76,1.05-1.37,1.94-1.84,2.66Z",
    fill: "#fde4cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.9,699.92c.04-.06,.09-.13,.13-.19h0c-.04,.05-.09,.12-.13,.19Z",
    fill: "#fde4cd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1055.45,738.09l-.52-2.61c-18.31,3.67-28.45-2.46-33.73-8.25-4.96-5.44-6.07-11.08-5.67-12.42,.79-1.91,15.57-21.34,105.44-129.56l3.74-4.5c8.73-10.53,65.98-43.46,66.56-43.79l-1.33-2.31c-2.37,1.36-58.25,33.5-67.28,44.4l-3.74,4.5c-104.59,125.94-105.61,129.37-105.95,130.5-.88,2.95,1.27,9.51,6.26,14.97,4.7,5.15,15.67,13.18,36.22,9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.83,858.14s.11,.19,.37,.51c2.31,2.9,15.98,16.28,52.94-13.09,40.97-32.56,18.6-163.69,28.05-180.24,9.45-16.53,28.16-102.99,107.91-88.43,0,0,46.58,19.53,50.91,49.99,0,0-42.68,77.8-50.92,87.38-7.23,8.42-53.13,59.12-30.91,102.29,3.8,7.36,11.88,10.71,19.33,9.14,.25-.05,.49-.11,.74-.18,1.46-.36,2.88-.92,4.23-1.7,1.08-.59,2.11-1.31,3.08-2.17,12.01-10.55,29.63-26.34,44.36-40.8,9.93-9.75,18.55-18.91,23.24-25.43,6.32-8.79,19.98-27.26,34.44-46.72,26.99-36.34,58.44-69.1,93.36-97.89,33.75-27.82,78.79-72.5,105.97-129.98,40.85-86.41,57.17-186.16,57.17-186.16l-224.34-81.55-36.06,112.73s-245.76,168.42-263.55,185.99c-17.8,17.56-20.11,141.15-22.96,153.28-1.81,7.69-.27,83.24,1.1,137.5,.61,24.33,1.2,44.37,1.42,52.1,.06,1.86,.09,3.01,.1,3.33,0,.07,0,.1,0,.1Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.77,839.24c1.28,5.42,17.14,32.2,61.46,1.71,44.31-30.49,61.85-113.81,103.01-161.68,41.16-47.88-12.1-124.02-12.1-124.02,0,0-78.57,83.41-87.22,107.4-5.19,14.38-28.06,73.11-45.25,118.97-7.71,20.55-14.27,38.52-17.6,48.75-.39,1.22-.74,2.32-1.03,3.3-.06,.16-.1,.32-.14,.47-.84,2.82-1.25,4.59-1.13,5.1Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21,629.27l2.58-.68c-.11-.42-11.75-42.61-58.32-51.92l-.52,2.61c44.9,8.98,56.16,49.58,56.27,49.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1352.03,819.88c1.87,2.69,3.78,5.25,5.71,7.68,1.46-.36,2.88-.92,4.23-1.69,1.08-.59,2.11-1.31,3.08-2.17,12.01-10.55,29.63-26.34,44.36-40.8-2.09-1.3-4.33-2.49-6.69-3.44-12.07-4.87-18-1.94-18-1.94l-29.3,24.17c-.25,.2-.49,.42-.72,.63h0c-5.09,4.77-6.32,12.31-2.68,17.56Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.66,820.62c1.74,2.51,3.53,4.89,5.34,7.13,.25-.05,.49-.11,.74-.18,1.46-.36,2.88-.92,4.23-1.69-2.3-2.74-4.57-5.69-6.76-8.86-2.55-3.69-3.14-10.81-.51-14.68l-1.08,.88c-4.77,3.95-5.15,12.78-1.96,17.4Z",
    fill: "#fde4cd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1179.31,860.09c.74,.09,1.49,.18,2.24,.24,4.91,.47,9.51-3.2,10.79-8.4h0c.06-.25,.11-.49,.16-.72l5.24-28.8s-.26-5.09-8.07-11.38c-3.75-3.02-8.25-5.07-11.89-6.37,.61,24.33,1.2,44.37,1.42,52.1,.06,1.86,.09,3.01,.1,3.33Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.31,860.19s.11,.19,.37,.51c.5,.06,1.01,.12,1.51,.16,4.31,.41,10.11-3.16,10.96-7.86l.19-1.06c-1.62,3.23-6.62,5.51-10.06,5.18-1.04-.1-2.07-.22-3.07-.35,.06,1.86,.09,3.01,.1,3.33,0,.07,0,.1,0,.1Z",
    fill: "#fde4cd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1044.08,830.37c-.39,1.22-.74,2.32-1.03,3.3,3.17,1.63,6.56,3.17,10.16,4.58,4.59,1.78,10.02-.49,12.67-5.15,0,0,0-.01,.02-.01,.12-.21,.23-.43,.34-.65l12.87-26.29s1.13-4.97-4.69-13.15c-3.77-5.3-9.31-9.26-12.73-11.38-7.71,20.55-14.27,38.52-17.6,48.75Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.9,829.7s.01,0,.02,0c0-.23,.03-.46,.05-.69-.04,.22-.06,.45-.07,.68Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1042.9,834.15c3.01,1.6,6.29,3.13,9.82,4.5,4.04,1.58,10.59-.3,12.69-4.58l.47-.98s0,.01-.02,.01c-2.44,2.67-7.87,3.5-11.09,2.25-3.86-1.51-7.44-3.2-10.71-4.98-.39,1.22-.74,2.32-1.03,3.3-.06,.16-.1,.32-.14,.47Z",
    fill: "#fde4cd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1358.5,828.06c3.23-.76,6.26-2.31,8.85-4.6,19.85-17.47,54.87-49.18,66.4-65.22,5.48-7.62,17.06-23.34,34.42-46.7,26.53-35.72,57.87-68.57,93.15-97.65,33.38-27.52,78.92-72.48,106.32-130.44l-2.41-1.14c-27.19,57.51-72.44,102.17-105.61,129.52-35.44,29.22-66.93,62.23-93.59,98.12-17.37,23.38-28.95,39.1-34.44,46.74-11.37,15.82-46.23,47.37-65.99,64.77-4.29,3.78-9.97,5.26-15.58,4.07-5.47-1.16-9.93-4.72-12.23-9.75-12.13-26.51-1.41-60.29,31.02-97.68l.79-.91c8.23-9.57,49.33-84.43,51.08-87.61,9.5-17.16,6.23-43.17,6.08-44.27l-2.64,.35c.03,.26,3.3,26.24-5.78,42.64-.43,.78-42.72,77.8-50.76,87.16l-.78,.91c-4.7,5.42-17.18,19.81-26.29,38.27-11.58,23.46-13.3,44.41-5.13,62.26,2.66,5.81,7.8,9.91,14.1,11.25,3.06,.65,6.13,.61,9.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.82,855.88c5.57-1.31,11.7-3.71,18.39-7.2l-1.23-2.36c-15.97,8.33-28.49,10.24-37.2,5.7-8.62-4.5-10.7-14.12-11.02-15.96,3.12-8.36,62.58-167.87,67.81-179.81,5.27-12.04,74.37-90.16,75.07-90.94l-1.99-1.77c-2.86,3.23-70.07,79.22-75.52,91.64-5.37,12.27-65.43,173.43-67.98,180.28l-.11,.31,.04,.33c.07,.52,1.75,12.69,12.48,18.29,5.73,2.99,12.86,3.49,21.28,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.99,531.31c13.3-14.55,11.93-35.71,11.87-36.6l-2.28,.16c.01,.21,1.35,21.09-11.28,34.9l1.69,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.49,541.86c16.44-10.87,20.27-31.73,20.43-32.61l-2.25-.4c-.04,.21-3.83,20.78-19.44,31.1l1.26,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.94,146.7l-27.3,154.02-279.59,45.48,56.86-283.86c91.19,18.1,175.2,47.61,250.03,84.37Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1373.35,
    y: 177.77,
    width: 206.2,
    height: 3.43,
    transform: "translate(1010.48 1591.93) rotate(-78.67)",
    fill: "#0d171e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.29,404.37c18.9-41.96,44.06-211.54,45.13-218.74l-3.4-.5c-.26,1.76-26.15,176.3-44.86,217.83l3.13,1.41Z",
    fill: "#0d171e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.39,862.87l5.63-1.74,17.4-24.65,11.35-51.97s26.16-42.32,26.74-42.46c.58-.14,15.69-2.27,15.69-2.27l-2.35,49.23-4.71,26.17-6.96,18.79-16.52,17.45-13.68,8.59-10.42,5.01-10.54,1.46-11.64-3.62Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1329.36,
    cy: 794.65,
    r: 119.62,
    fill: "#f9bf52"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1329.36,
    cy: 794.65,
    r: 103.45,
    transform: "translate(-172.54 1172.75) rotate(-45)",
    fill: "#fffbbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.24,799.94c-4.19-5.09-12.07-10.06-23.64-14.92-2.42-1.01-5.76-2.34-10.01-4-13.84-5.38-20.76-11.11-20.78-17.19-.01-3.92,1.39-7.03,4.2-9.33,2.82-2.3,6.67-3.45,11.56-3.47,5.05-.02,9.3,1.19,12.75,3.62,3.45,2.44,6.45,6.34,8.99,11.7l20.46-7.57c-3.2-8.64-8.21-15.16-15.03-19.55-4.47-2.87-9.67-4.79-15.6-5.77l-.05-15.85-19.96,.07,.05,15.9c-7.18,1.3-13.28,4.07-18.29,8.29-7.21,6.08-10.8,13.95-10.77,23.63,.02,5.7,1.24,10.8,3.68,15.31,2.43,4.51,5.94,8.21,10.52,11.09,4.64,3,12.85,6.62,24.64,10.88,1.72,.59,3.04,1.07,3.96,1.44,6.73,2.45,11.39,4.92,13.97,7.41,2.59,2.49,3.89,5.59,3.9,9.3,.02,4.68-1.72,8.39-5.2,11.15-3.49,2.75-8.24,4.14-14.26,4.16-5.32,.02-9.94-1.43-13.84-4.35-3.91-2.92-7.46-7.57-10.65-13.96l-20.46,9.18c3.96,9.45,9.78,16.58,17.46,21.39,4.64,2.91,9.9,4.93,15.76,6.06l.06,17.06,19.96-.07-.06-16.35c9.09-1.09,16.5-4.13,22.21-9.16,7.23-6.37,10.83-15.09,10.8-26.17-.03-8.23-2.13-14.88-6.32-19.98Z",
    fill: "#f9bf52"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1403.52,722.53c-33.38,80.77-120.26,108.47-167.06,117.69,16.91,34.4,52.34,58.02,93.25,57.88,57.14-.19,103.29-46.67,103.1-103.8-.1-27.92-11.25-53.22-29.29-71.77Z",
    fill: "#f9bf52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1268.92,898.73c18.28,10.66,39.13,16.3,60.85,16.23,.38,0,.69-.31,.68-.69,0-.38-.31-.69-.69-.68-31.76,.11-61.67-12.16-84.21-34.55-22.54-22.39-35.01-52.21-35.12-83.98-.22-65.58,52.95-119.11,118.52-119.34,.38,0,.69-.31,.68-.69,0-.38-.31-.69-.69-.68-66.34,.23-120.12,54.38-119.89,120.71,.11,32.13,12.72,62.3,35.53,84.95,7.39,7.34,15.57,13.61,24.34,18.72Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.37,898.7c.1,.06,.22,.09,.35,.09,57.42-.19,103.98-47.07,103.78-104.49-.19-57.42-47.07-103.98-104.49-103.78-.38,0-.69,.31-.68,.69,0,.38,.31,.69,.69,.68,27.45-.09,53.29,10.51,72.77,29.85,19.48,19.34,30.25,45.11,30.35,72.56,.19,56.66-45.75,102.92-102.42,103.12-.38,0-.69,.31-.68,.69,0,.25,.14,.47,.34,.59Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.5,734.6s.05,.03,.07,.04c.35,.15,.75,0,.91-.35,.09-.2,8.85-19.61,27.71-26.49,.36-.13,.54-.52,.41-.88-.13-.35-.52-.54-.88-.41-19.42,7.09-28.41,27.03-28.5,27.23-.14,.32-.02,.7,.28,.87Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.97,742.17s.05,.03,.07,.04c.35,.15,.75,0,.91-.35,.09-.2,8.85-19.6,27.71-26.49,.36-.13,.54-.52,.41-.88-.13-.35-.53-.54-.88-.41-19.42,7.09-28.41,27.02-28.5,27.22-.14,.32-.02,.7,.28,.87Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.53,742.49c.24,.14,.56,.12,.79-.07,4.89-4.12,10.94-6.86,17.97-8.14l.57-.1-.06-16.47c0-.38-.31-.69-.69-.68-.38,0-.69,.31-.68,.69l.05,15.33c-7.03,1.36-13.1,4.17-18.05,8.33-.29,.24-.33,.68-.08,.97,.05,.06,.11,.11,.18,.15Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.45,764.43c.1,.06,.22,.09,.35,.09,.38,0,.69-.31,.68-.69-.01-3.74,1.28-6.62,3.95-8.79,2.68-2.18,6.42-3.3,11.13-3.31,4.88-.02,9.04,1.16,12.35,3.5,3.33,2.35,6.28,6.2,8.77,11.44l.27,.57,21.69-8.03-.24-.65c-3.24-8.74-8.39-15.44-15.3-19.88-4.52-2.91-9.86-4.88-15.87-5.87-.37-.06-.73,.19-.79,.57-.06,.38,.19,.73,.57,.79,5.82,.96,10.99,2.86,15.34,5.67,6.48,4.17,11.36,10.42,14.51,18.56l-19.22,7.11c-2.53-5.16-5.54-9-8.94-11.4-3.56-2.51-7.98-3.77-13.15-3.75-5.03,.02-9.07,1.24-12,3.62-2.97,2.42-4.47,5.74-4.45,9.86,0,.25,.14,.47,.34,.59Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.26,872.19c.1,.06,.22,.09,.35,.09,.38,0,.69-.31,.68-.69l-.05-15.74c8.93-1.17,16.32-4.28,21.97-9.25,7.36-6.48,11.07-15.46,11.03-26.68,0-.38-.31-.69-.69-.68-.38,0-.69,.31-.68,.69,.04,10.81-3.52,19.44-10.56,25.65-5.57,4.9-12.91,7.92-21.84,8.99l-.61,.07,.06,16.96c0,.25,.14,.47,.34,.59Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.61,849.82c4.41,2.57,9.39,4.4,14.85,5.46,.37,.07,.73-.17,.81-.54s-.17-.73-.54-.81c-5.76-1.12-10.97-3.11-15.53-5.97-7.35-4.61-13.04-11.49-16.92-20.46l19.24-8.64c3.15,6.16,6.7,10.73,10.56,13.61,4.02,2.99,8.81,4.5,14.26,4.48,6.15-.02,11.09-1.47,14.69-4.31,3.64-2.88,5.48-6.81,5.46-11.69-.01-3.89-1.4-7.18-4.11-9.79-.28-.26-.71-.25-.97,.02-.26,.27-.25,.71,.02,.97,2.44,2.34,3.68,5.31,3.69,8.81,.01,4.5-1.6,7.97-4.94,10.61-3.35,2.64-8,3.99-13.84,4.01-5.15,.02-9.66-1.4-13.43-4.21-3.8-2.84-7.32-7.45-10.45-13.71l-.29-.59-21.67,9.73,.26,.62c4,9.54,9.96,16.84,17.72,21.71,.38,.24,.76,.47,1.15,.69Z",
    fill: "#211516"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1241.42,679.58l15.79,10.89s2.02,92.66-2.89,113.61c-4.91,20.95-8.2,39.67-40.33,55.94-32.13,16.27,10.29-172.63,10.29-172.63l17.14-7.81Z",
    fill: "#f4ce96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.84,866.63c7.99-1.89,18.69-6.9,32.62-17.97,28.11-22.35,26.98-88,26.16-135.93-.37-21.26-.68-39.61,2.22-44.69l-2.31-1.32c-3.26,5.71-2.97,22.64-2.57,46.06,.77,44.71,1.93,112.26-25.15,133.8-21.59,17.16-34.83,19.3-42.13,18.07-5.67-.95-8.34-3.96-9.04-4.88-.29-9.5-5.38-180.74-2.66-192.28,.77-3.26,1.47-13.86,2.44-28.52,2.57-38.96,7.36-111.49,20.16-124.12,8.11-8,76.61-62.61,144.91-104.04l-1.38-2.28c-68.47,41.54-137.24,96.38-145.4,104.43-13.52,13.34-18.17,83.76-20.95,125.84-.92,13.99-1.65,25.04-2.37,28.09-2.87,12.15,2.38,185.98,2.6,193.37v.36l.2,.3c.13,.2,3.17,5,10.92,6.35,2.98,.52,6.85,.54,11.74-.62Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1758.82 1111.17 1310.53 951.77 862.25 1111.17 860.92 1107.43 1310.53 947.57 1760.15 1107.43 1758.82 1111.17",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1151.02,1164.04h0c-2.85,0-5.17-2.31-5.17-5.17v-153.14c0-2.85,2.31-5.17,5.17-5.17h0c2.85,0,5.17,2.31,5.17,5.17v153.14c0,2.85-2.31,5.17-5.17,5.17Z",
    fill: "#21212d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1177.07,1232.86l-26.05-65.99-26.05,65.99c-.12,.22-.2,.43-.2,.66,0,3.01,11.75,5.45,26.25,5.45s26.25-2.44,26.25-5.45c0-.22-.07-.44-.2-.66Z",
    fill: "#f9edcb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1151.02,
    cy: 1175.32,
    r: 21.14,
    fill: "#fef8e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.02,1196.85c-11.87,0-21.53-9.66-21.53-21.53s9.66-21.53,21.53-21.53v.79c-11.44,0-20.74,9.3-20.74,20.74s9.3,20.74,20.74,20.74v.79Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.48,1239.32c-22.49-.15-28.62-2.82-29.81-5.04-.37-.7-.22-1.31-.06-1.6l15.47-39.21,.74,.29-15.52,39.31s-.2,.35,.09,.86c.75,1.33,5.09,4.43,29.1,4.59v.79Z",
    fill: "#1d1d1b"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1170.96,1615.66s9.12-27.59,106.16-22.47c110.95,5.86,186.52-13.3,206.16,22.47l-153.75,57.07-158.58-57.07Z",
    fill: "#3a3a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.49,1664.83s-88.04-53.04-118.91-61c-30.88-7.96-52.26,2.54-55.62,11.83-3.36,9.29-6.51,34.38,14.02,49.17,8.89,6.4,110.44,36.6,137.29,43.65,0,0,24.92-10.48,23.22-43.65Z",
    fill: "#3a3a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.85,1654.64c.26,0,.52-.14,.67-.38,.22-.37,.1-.85-.27-1.07-84.3-50.39-111.92-52.88-113.05-52.96-.44-.03-.8,.29-.83,.72-.03,.43,.29,.8,.72,.83h0c.28,.02,28.54,2.64,112.36,52.74,.13,.08,.26,.11,.4,.11Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.37,1717.07l39.82-20.28-19.15-37.6-32.48,16.54h0s-53.7-.46-56.27,2.05c-2.57,2.51,55.6,45.63,68.08,39.28Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.04,1710.1c-11.43-12.6-17.65-30.88-19.59-37.37l-5.9,3s-53.7-.46-56.27,2.05c-2.57,2.51,55.6,45.63,68.08,39.28l13.67-6.96Z",
    fill: "#8990c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.76,1664.83s88.04-53.04,118.91-61c30.88-7.96,52.26,2.54,55.62,11.83,3.36,9.29,6.51,34.38-14.02,49.17-8.89,6.4-117.55,38.53-144.41,45.58,0,0-17.8-12.41-16.1-45.58Z",
    fill: "#3a3a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.86,1711.19c.25,0,.5-.12,.65-.35,.24-.36,.14-.84-.22-1.08-14.86-9.8-15.71-40.43-15.75-44.48,6.16-3.58,82.65-47.91,113.15-59.34,.4-.15,.61-.6,.46-1-.15-.4-.6-.61-1-.46-31.76,11.9-112.96,59.2-113.78,59.68l-.38,.22v.44c-.02,1.44-.09,35.32,16.45,46.23,.13,.09,.28,.13,.43,.13Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1180.08,1614.86c.24,0,.48-.11,.63-.32,.05-.07,3.14-4.07,13.22-3.95,.45,.01,.78-.34,.79-.77,0-.43-.34-.78-.77-.79-11.02-.14-14.37,4.41-14.51,4.6-.25,.35-.17,.84,.19,1.09,.14,.1,.29,.14,.45,.14Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.09,1618.76c.2,0,.41-.08,.56-.24,.06-.06,3.71-3.57,13.66-1.97,.42,.07,.83-.22,.89-.65,.07-.43-.22-.83-.65-.89-10.89-1.74-14.87,2.26-15.03,2.43-.3,.31-.29,.81,.02,1.1,.15,.14,.35,.22,.54,.22Z",
    fill: "#211516"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1297.55,1362.72s-10.4,29.84-11.65,32.35c-1.25,2.51-7.61,14.08-5.33,27.71,2.28,13.62,43.45,18.47,43.45,18.47l-.75-93.5s-18.39-2.23-25.72,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.56,1362.72s10.4,29.84,11.65,32.35c1.25,2.51,7.61,14.08,5.33,27.71-2.28,13.62-43.45,18.47-43.45,18.47l.75-93.5s18.39-2.23,25.72,14.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1336.96 1426.54 1311 1426.09 1312.39 1404.89 1334.31 1404.89 1336.96 1426.54",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.82,1413.67c2.5,2.1,5.92,3.77,9.14,4.19,.53,.01,1.08,.02,1.64,.02h0s.08,0,.12,0c.04,0,.08,0,.12,0h0c.56,0,1.11,0,1.64-.02,3.78-.49,7.97-2.64,10.76-5.35l-.93-7.62h-21.92l-.58,8.78Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.9,1368.22c-1.06-2.12-2.44-3.54-3.8-4.48-2.75-1.27-7.25-2.91-12.99-3.55h-.71c-5.74,.64-10.24,2.28-12.99,3.55-1.35,.95-2.74,2.36-3.8,4.48-.5,3.91-1.12,11.14-1.24,18.35-.1,6.49,1.64,12.9,5.21,18.14,2.69,3.95,6.57,7.5,11.93,8.02,.37,0,.76,0,1.16,0h.16c.4,0,.78,0,1.16,0,5.36-.52,9.23-4.07,11.93-8.02,3.58-5.25,5.32-11.66,5.21-18.14-.11-7.22-.73-14.44-1.24-18.35Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1336.67,1390.78c0,3.33,2.7,6.03,6.03,6.03s6.03-2.7,6.03-6.03-2.7-6.03-6.03-6.03-6.03,2.7-6.03,6.03Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.15,1394.51c1.27,0,2.11-.95,2.39-1.9,.33-1.12-.05-2.22-.96-2.78-1.3-.81-2.48-.34-3.13,.07,.26-.64,.65-1.11,1.18-1.4,1.18-.65,2.64-.17,2.65-.17,.1,.03,.21-.02,.24-.12,.03-.1-.02-.21-.12-.24-.07-.02-1.63-.53-2.96,.2-.77,.42-1.29,1.17-1.55,2.21l-.17,.67,.49-.49c.06-.06,1.48-1.44,3.16-.4,.93,.57,1.01,1.62,.8,2.35-.22,.76-.89,1.64-2.05,1.62-.1,0-.19,.08-.2,.19,0,.11,.08,.19,.19,.2h.04Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1310.41,1390.78c0,3.33-2.7,6.03-6.03,6.03s-6.03-2.7-6.03-6.03,2.7-6.03,6.03-6.03,6.03,2.7,6.03,6.03Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.93,1394.51c-1.27,0-2.11-.95-2.39-1.9-.33-1.12,.05-2.22,.96-2.78,1.3-.81,2.48-.34,3.13,.07-.26-.64-.65-1.11-1.18-1.4-1.18-.65-2.64-.17-2.65-.17-.1,.03-.21-.02-.24-.12-.03-.1,.02-.21,.12-.24,.07-.02,1.63-.53,2.96,.2,.77,.42,1.29,1.17,1.55,2.21l.17,.67-.49-.49c-.06-.06-1.48-1.44-3.16-.4-.93,.57-1.01,1.62-.8,2.35,.22,.76,.89,1.64,2.05,1.62,.1,0,.19,.08,.2,.19,0,.11-.08,.19-.19,.2h-.04Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1321.99,1396.64c.1,0,.19-.07,.22-.17,.03-.12-.05-.24-.17-.26-1.42-.3-2.32-2.06-2.58-2.63,2.02-1.08,3.25-2.48,3.67-4.17,.67-2.76-1.08-5.25-1.15-5.35-.07-.1-.21-.12-.31-.05-.1,.07-.12,.21-.05,.31,.02,.02,1.71,2.44,1.08,5-.39,1.61-1.61,2.95-3.62,3.98l-.18,.09,.07,.19c.04,.11,1.05,2.67,2.98,3.08,.02,0,.03,0,.05,0Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.19,1386.95c0,.68-.55,1.23-1.23,1.23s-1.23-.55-1.23-1.23,.55-1.23,1.23-1.23,1.23,.55,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.89,1387.19c0,.68,.55,1.23,1.23,1.23s1.23-.55,1.23-1.23-.55-1.23-1.23-1.23-1.23,.55-1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.75,1384.97s22.26-10.75,24.1-24.45l.95,3.11s7.72,20.16,17.26,21.25c0,0,8.34-30.23-15.59-36.24-23.93-6.01-28.63,17.68-26.72,36.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.03,1399.09c.12-.02,7.46-.18,7.46-.18,0,0-.93,3.04-3.66,3.1-2.73,.07-3.8-2.92-3.8-2.92Z",
    fill: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.2,1384.54c-.11,0-.22-.04-.32-.12-3.12-2.65-7.55-1.19-7.59-1.17-.25,.08-.53-.05-.62-.31-.09-.26,.05-.53,.31-.62,.2-.07,5-1.65,8.54,1.35,.21,.17,.23,.48,.06,.69-.1,.11-.23,.17-.37,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1,1384.44c-.14,0-.28-.06-.38-.18-.17-.21-.14-.52,.07-.69,3.61-2.91,8.37-1.22,8.57-1.14,.25,.09,.38,.37,.29,.63-.09,.25-.37,.38-.63,.29-.04-.02-4.45-1.58-7.62,.99-.09,.07-.2,.11-.31,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.77,1396.65s2.22,16.32,15.75,16.09l-15.75-16.09Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.05,1396.2s-2.22,16.77-15.75,16.54l9.93-22.99,5.82,6.45Z",
    fill: "#fed497"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1309.48,1476.21l33.98,16.94,40.85,25.18,10.4,12.35,19.83,30.52c68.7-15.31,52.23-54.21,48.14-61.07-11.13-18.68-36.21-40.29-50.03-56.23-3.2-3.69-6.52-7.02-9.69-9.93-9.46-8.69-21.88-13.44-34.72-13.44h-31.74l-27.01,55.67Zm81.09,8.78s3.92,3.44,4.1,3.62c9.11,9.09,20.99,20.95,20.99,20.95l1.48,.51-22.48,11.13s-2.28,.89-2.51,.41c-.11-.22-1.57-36.62-1.57-36.62Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.92,1420.54h-31.74c-12.85,0-25.26,4.75-34.72,13.44-3.17,2.91-6.5,6.25-9.69,9.93-13.82,15.94-38.9,37.55-50.03,56.23-4.09,6.86-20.56,45.76,48.14,61.07l19.83-30.52,10.4-12.35,40.85-25.18,33.98-16.94-27.01-55.67Zm-55.65,101.08c-.23,.48-2.51-.41-2.51-.41l-22.48-11.13,1.48-.51s11.89-11.86,20.99-20.95c.18-.18,4.1-3.62,4.1-3.62,0,0-1.47,36.4-1.57,36.62Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.28,1521.62l-1.14,72.57s76.49,17.12,144.26-.91c1.66-.44-3.53-74.67-3.53-74.67,0,0,0-13.4-7.06-17.54-7.06-4.14-64.34-76.02-65.72-76.02s-66.82,96.57-66.82,96.57Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.59,1443.91c-.43,0-.79-.33-.82-.77-.03-.45,.32-.84,.77-.87,25.01-1.57,33.17-18.7,33.25-18.87,.19-.41,.68-.59,1.09-.4,.41,.19,.59,.68,.41,1.09-.08,.18-8.61,18.19-34.64,19.83-.02,0-.03,0-.05,0Z",
    fill: "#211516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.02,1420.54h55.14s-9.97,17.26-29.02,17.19c-8.74-.03-18.08-3.25-26.12-17.19Z",
    fill: "#fed497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.86,1510.6l8.62,41.3s17.73-14.44,17.73-16.01-5.61-20.78-6.21-21.15c-.59-.37-20.15-4.14-20.15-4.14Z",
    fill: "#97a0d8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1265.31 1485.3 1265.31 1479.46 1321.65 1497.71 1298.04 1520.83 1265.31 1485.3",
    fill: "#e5e7ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1380.11 1485.3 1380.11 1479.46 1323.78 1497.71 1347.38 1520.83 1380.11 1485.3",
    fill: "#e5e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.88,1481.46c0,2.15,4.29,87.28,4.29,87.28l55.09,14.31v-83.7l-59.38-17.89Z",
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.63,1481.46c0,2.15-4.29,87.28-4.29,87.28l-55.09,14.31v-83.7l59.38-17.89Z",
    fill: "#fee8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.29,1497.71h6.67c.64,0,1.17,.52,1.17,1.17v82.84c0,.74-.6,1.33-1.33,1.33h-6.33c-.74,0-1.33-.6-1.33-1.33v-82.84c0-.64,.52-1.17,1.17-1.17Z",
    fill: "#f9cd75"
  }), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1318.12,
    y: 1507.08,
    width: 9,
    height: 4.14,
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("g", {
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1318.12,
    y: 1572.05,
    width: 9,
    height: 4.14,
    fill: "#f9cd75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1294.64,1541.22c3.5-3.54,.26-8.04,.26-8.04,.7-2.91,.61-4.93,.37-6.17-.16-.86-1.02-1.39-1.86-1.13-3.83,1.15-14.88,4.52-21.71,7.05-4.71-.71-6.38-3.01-6.38-3.01l-.12,.2c-.09-4.09-.21-9.2-.21-9.77,0-.97-1.56-2.54-3.99,.55-2.44,3.09-7.15,11.37-7.15,11.37h-14.24l-7.84,27.12s29.55,4.18,34.09,4.5c4.55,.32,20.37-3.4,25.08-7.3,4.71-3.9,3.69-7.39,3.69-7.39,3.5-4.21,0-7.97,0-7.97Z",
    fill: "#f7c789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.89,1538.44c-.23,0-.45-.15-.52-.38-.09-.29,.06-.6,.35-.69,4.04-1.31,9.84-4.63,9.9-4.67,.26-.15,.6-.06,.75,.2,.15,.26,.06,.6-.2,.75-.24,.14-5.96,3.42-10.11,4.76-.06,.02-.11,.03-.17,.03Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.89,1545.38c-.26,0-.49-.18-.54-.45-.06-.3,.14-.58,.44-.64,5.08-.94,9.53-3.52,9.57-3.55,.26-.15,.6-.06,.75,.2,.15,.26,.06,.6-.2,.75-.19,.11-4.66,2.7-9.93,3.68-.03,0-.07,0-.1,0Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.11,1553.3c-.25,0-.48-.18-.54-.43-.06-.3,.12-.59,.42-.65,4.36-.94,8.31-3.46,8.35-3.49,.25-.16,.59-.09,.76,.17,.16,.25,.09,.59-.17,.76-.17,.11-4.16,2.65-8.71,3.63-.04,0-.08,.01-.12,.01Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1257.3,1524.96l-3.45,38.94s-12.32,1.35-36.09-5.89c-23.78-7.24-4.06-46.19-2.6-46.79,1.46-.6,17.26,1.38,17.26,1.38l24.89,12.36Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.51,1564.63l-.69-.02c-2.58-.09-63.21-2.55-75.14-34.52-.19-.36-5.22-10.72,.14-25.42,5.31-14.57,42.59-50.77,44.17-52.3,.59-.68,15.56-17.64,22.87-22.87,.32-.23,.77-.15,.99,.16,.23,.32,.16,.76-.16,.99-7.17,5.14-22.51,22.52-22.67,22.69-.43,.41-38.66,37.55-43.86,51.81-5.14,14.1-.22,24.27-.17,24.37,10.96,29.36,66.37,33.26,73.2,33.63,.73-9.88,3-34.05,3.36-37.78-23.44-11.82-46.4-22.77-46.63-22.88-.35-.17-.51-.59-.34-.95,.17-.35,.6-.5,.95-.34,.23,.11,23.48,11.2,47.09,23.12l.43,.22-.04,.48c-.03,.29-2.72,28.83-3.45,38.93l-.05,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.35,1511.31c-.18,0-.36-.07-.5-.2-.28-.27-.29-.72-.01-1.01l25.38-26.09c.27-.28,.73-.29,1.01-.01,.28,.27,.29,.72,.01,1.01l-25.38,26.09c-.14,.14-.33,.22-.51,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.28,1523.18h-.03c-.39-.02-.7-.35-.68-.74l1.57-41.01c.01-.39,.3-.71,.74-.68,.39,.01,.7,.35,.68,.74l-1.57,41.01c-.01,.38-.33,.68-.71,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.76,1510.28c-.24,0-.47-.12-.6-.33l-4.35-6.91c-.21-.33-.11-.77,.22-.98,.33-.21,.77-.11,.98,.22l4.35,6.91c.21,.33,.11,.77-.22,.98-.12,.07-.25,.11-.38,.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1349.79,1541.22c-3.5-3.54-.26-8.04-.26-8.04-.52-2.13-.6-3.78-.52-5,.1-1.46,1.56-2.43,2.96-2.01,4.47,1.35,14.43,4.42,20.75,6.76,4.71-.71,6.38-3.01,6.38-3.01l.12,.2c.09-4.09,.21-9.2,.21-9.77,0-.97,1.56-2.54,3.99,.55,2.44,3.09,7.15,11.37,7.15,11.37h14.24l7.84,27.12s-29.55,4.18-34.09,4.5c-4.55,.32-20.37-3.4-25.08-7.3-4.71-3.9-3.69-7.39-3.69-7.39-3.5-4.21,0-7.97,0-7.97Z",
    fill: "#f7c789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.54,1538.44c.23,0,.45-.15,.52-.38,.09-.29-.06-.6-.35-.69-4.04-1.31-9.84-4.63-9.9-4.67-.26-.15-.6-.06-.75,.2-.15,.26-.06,.6,.2,.75,.24,.14,5.96,3.42,10.11,4.76,.06,.02,.11,.03,.17,.03Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.54,1545.38c.26,0,.49-.18,.54-.45,.06-.3-.14-.58-.44-.64-5.08-.94-9.53-3.52-9.57-3.55-.26-.15-.6-.06-.75,.2-.15,.26-.06,.6,.2,.75,.19,.11,4.66,2.7,9.93,3.68,.03,0,.07,0,.1,0Z",
    fill: "#f0b086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.32,1553.3c.25,0,.48-.18,.54-.43,.06-.3-.12-.59-.42-.65-4.36-.94-8.31-3.46-8.35-3.49-.25-.16-.59-.09-.76,.17-.16,.25-.09,.59,.17,.76,.17,.11,4.16,2.65,8.71,3.63,.04,0,.08,.01,.12,.01Z",
    fill: "#f0b086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1387.12,1524.96l3.45,38.94s12.32,1.35,36.09-5.89c23.78-7.24,4.06-46.19,2.6-46.79-1.46-.6-17.26,1.38-17.26,1.38l-24.89,12.36Z",
    fill: "#ffc0ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.91,1564.63l-.05-.68c-.73-10.1-3.42-38.64-3.45-38.93l-.04-.48,.43-.22c23.61-11.92,46.86-23.01,47.09-23.12,.35-.17,.78-.02,.95,.34,.17,.36,.02,.78-.34,.95-.23,.11-23.18,11.06-46.63,22.88,.35,3.73,2.62,27.9,3.36,37.78,6.82-.37,62.23-4.26,73.17-33.56,.08-.17,5-10.34-.14-24.44-5.2-14.26-43.44-51.4-43.82-51.77-.19-.22-15.53-17.6-22.7-22.73-.32-.23-.39-.67-.16-.99,.23-.32,.67-.39,.99-.16,7.31,5.23,22.27,22.19,22.9,22.91,1.54,1.49,38.82,37.69,44.13,52.26,5.36,14.7,.32,25.06,.11,25.49-11.9,31.9-72.53,34.36-75.11,34.45l-.69,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.07,1511.31c-.18,0-.37-.07-.51-.22l-25.38-26.09c-.27-.28-.27-.73,.01-1.01,.28-.27,.73-.27,1.01,.01l25.38,26.09c.27,.28,.27,.73-.01,1.01-.14,.13-.32,.2-.5,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.15,1523.18c-.38,0-.7-.3-.71-.68l-1.57-41.01c-.01-.39,.29-.72,.68-.74,.45-.03,.72,.29,.74,.68l1.57,41.01c.01,.39-.29,.72-.68,.74h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.67,1510.28c-.13,0-.26-.04-.38-.11-.33-.21-.43-.65-.22-.98l4.35-6.91c.21-.33,.65-.43,.98-.22,.33,.21,.43,.65,.22,.98l-4.35,6.91c-.13,.21-.37,.33-.6,.33Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.57,
    y: 1874.94,
    width: 2253.33,
    height: 5.7,
    fill: "#492f2f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarship);
export default __webpack_public_path__ + "static/media/scholarship.89cacfbd74f329c3a1778ccf7d3451eb.svg";
export { ForwardRef as ReactComponent };